import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { getLocation } from '../reducers';
import Modal from './Modal';
import ImageList from './ImageList';
import SectionHeader from '../components/SectionHeader';

class Location extends Component { //eslint-disable-line
  componentDidMount() {
    this.fetchData();
    document.querySelector('.main-wrapper').classList.add('on-full');
  }
  componentWillUnmount() { // eslint-disable-line
    document.querySelector('.main-wrapper').classList.remove('on-full');
  }
  componentDidUpdate(prevProps) {
    const { edition } = this.props;
    if (edition !== prevProps.edition) {
      this.fetchData();
    }
  }
  fetchData() {
    const { fetchLocation, edition } = this.props;
    fetchLocation(edition);
  }
  render() { //eslint-disable-line
    const { lang, location, edition } = this.props;
    const { body, title, images } = location;
    const FormattedHtml = () => ({ __html: body });
    const style = {
      color: edition.background,
    };

    return (
      <div className="fold fold--location fold--main fold--main--full">
        <div className="fold--main__inner">
          <Modal background={edition.background} />
          <section className="fold__col fold__col--main">
            <div className="content-col content-col--w-side">
              <SectionHeader lang={lang} title="location" />
              <div className="content-col__main">
                <div className="scroll-wrapper">
                  <div className="scroll-area">
                    <h2 style={style} className="field-sub-title">{title}</h2>
                    <div className="fold__col__body">
                      <div className="field-body" dangerouslySetInnerHTML={FormattedHtml()} />
                    </div>
                  </div>
                </div>
              </div>
              { images && images.length > 0 ?
                (<div className="content-col__side">
                  <div className="fold__col__side">
                    <div className="content-col__side-images">
                      <ImageList images={location.images} title={title} />
                    </div>
                  </div>
                </div>) : null
              }
            </div>
          </section>
        </div>
      </div>
    );
  }
}

Location.propTypes = {
  lang: PropTypes.string.isRequired,
  location: PropTypes.shape({
    body: PropTypes.string,
  }),
  fetchLocation: PropTypes.func.isRequired,
  edition: PropTypes.shape({
    background: PropTypes.string,
    backgroundTextColor: PropTypes.string,
    id: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
};

Location.defaultProps = {
  location: {},
};

const mapStateToProps = (state, { edition }) => ({
  location: getLocation(state, edition),
  edition,
});

Location = connect( //eslint-disable-line
  mapStateToProps,
  actions,
)(Location);

export default Location;



// WEBPACK FOOTER //
// ./js/containers/Location.js